  <template>
  <div>
    <div class="search-container">
      <!-- 产品分类  -->
      <div class="flex">
        <div>产品分类</div>
        <el-select
          v-model="vModelClass"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in classList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 资料类型 -->
      <div class="flex">
        <div>资料类型</div>
        <el-select
          v-model="vModelType"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in docTypeList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 资料名称 -->
      <div class="flex">
        <div>资料名称</div>
        <el-input
          placeholder="请输入内容"
          v-model="docName"
          clearable
          @input="getList"
        >
        </el-input>
      </div>

      <!-- 语言 -->
      <div class="flex">
        <div>语言</div>
        <el-select
          v-model="vModelLanguage"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in languageList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 应用领域 -->
      <div class="flex">
        <div>应用领域</div>
        <el-select
          v-model="vModelField"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in fieldList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 标准国别 -->
      <div class="flex">
        <div>标准国别</div>
        <el-select
          v-model="vModelNation"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in nationList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 主体材质 -->
      <div class="flex">
        <div>主体材质</div>
        <el-select
          v-model="vModelMainMaterial"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in mainMaterialList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 制式 -->
      <div class="flex">
        <div>制式</div>
        <el-select
          v-model="vModelZhishi"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in zhishiList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 产品系列 -->
      <div class="flex">
        <div>产品系列</div>
        <el-select
          v-model="vModelProductSerial"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in productSerialList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 标准类型 -->
      <div class="flex">
        <div>标准类型</div>
        <el-select
          v-model="vModelBiaozhun"
          multiple
          placeholder="请选择"
          filterable
          @change="getList"
        >
          <el-option
            v-for="item in biaozhunList"
            :key="item.libKey"
            :label="item.libTitle"
            :value="item.libKey"
          >
          </el-option>
        </el-select>
      </div>

      <div style="margin-left: 60px">
        <el-button @click="getList" type="danger" style="background: #f42434"
          >查询</el-button
        >
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <!-- <div style="margin-bottom:20px">
          <el-button @click="getList" type="danger" style="background:#f42434">查看</el-button>
        <el-button @click="download" type="danger" icon="el-icon-download">下载</el-button>
</div> -->

    <el-table
      stripe
      :data="list"
      style="width: 100%"
      v-loading="loading"
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center' }"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column
      type="selection"
      width="55">
      
      
      </el-table-column> -->
      <el-table-column type="index" label="序号" width="50"> </el-table-column>
      <el-table-column prop="classNameV" label="产品分类"> </el-table-column>
      <el-table-column prop="docTypeV" label="资料类型"> </el-table-column>

      <el-table-column prop="docName" label="资料名称"> </el-table-column>
      <el-table-column prop="docLanguageV" label="语言"> </el-table-column>
      <el-table-column label="使用状态">
          
        <template #default="scope">
          {{ scope.row.invalidState == "true" ? "可用" : "不可用" }}
        </template>
      </el-table-column>

      <el-table-column label="分类">
        <el-table-column prop="applyAreaName" label="一级应用领域">
        </el-table-column>
        <el-table-column prop="stardardNationV" label="二级 标准国别/组织">
        </el-table-column>

        <el-table-column prop="mainMaterial" label="三级 主体材质">
        </el-table-column>
        <el-table-column prop="productSerialV" label="四级 产品系列">
        </el-table-column>
        <el-table-column prop="nationalStandardV" label="五级 制式">
        </el-table-column>
        <el-table-column prop="standardTypeV" label="六级 标准类型">
        </el-table-column>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template #default="scope">
          <!-- <el-button @click="goDetail(scope.row.id)" type="primary" plain
            >查看</el-button
          > -->
          <el-button
            @click="download(scope.row.storeFilename, scope.row.id)"
            type="danger"
            plain
            icon="el-icon-download"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      style="text-align: center; margin-top: 20px; width: 100%"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="start"
      :page-sizes="pageSizes"
      background
      :page-size="limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>


  <script>
// import { apizhishiList, apiZidianList } from "../../api/zhishi";
export default {
  created() {
    this.getList();
    this.getProClassList(); //分类
    this.getdocTypeList(); //文档类型
    this.getlanguageList(); //文档语言
    this.getFieldList(); //领域
    this.getNationList(); //标准国别
    this.getMainMaterialList(); //主体材质
    this.getZhishiList(); //制式
    this.getBiaozhunList(); //标准类型
    this.getProductSerialList(); //产品系列
  },
  data() {
    return {
      multipleSelection: "", //多选选择的内容
      loading: false,
      list: [],
      start: 1, //当前页
      limit: 10, //限制页数
      pageSizes: [5, 10, 15, 20, 100],
      total: 0, //总条数

      classList: [], //产品分类下拉
      vModelClass: "", //绑定的产品分类

      docTypeList: [], //文档类型下拉
      vModelType: "", //文档类型绑定

      docName: "", //绑定的资料名称

      languageList: [], //文档语言
      vModelLanguage: "", //文档语言绑定

      fieldList: [], //领域下拉
      vModelField: "", //绑定的领域

      nationList: [], //标准国别
      vModelNation: "", //标准国别绑定

      mainMaterialList: [], //主体材质
      vModelMainMaterial: "", //绑定的主体材质

      zhishiList: [], //制式
      vModelZhishi: "", //绑定的制式

      biaozhunList: [], //标准类型
      vModelBiaozhun: "", //绑定的标准类型

      productSerialList: [], //产品系列
      vModelProductSerial: "", //绑定的产品系列
    };
  },
  watch: {
    vModelClass(newVal, oldVal) {
      this.getProductSerialList();
    },
  },
  methods: {
    // goDetail(id) {
    //   apizhishiList({
    //     postType: "reviewSign",
    //     docId: id,
    //   });

    //   this.$router.push({
    //     name: "ZhishiAdd",
    //     params: {
    //       id,
    //     },
    //   });
    // },

    //下载
    download(storeFilename, id) {
      this.$axios.postReq("/meide/REST/knowledgeBase", {
        postType: "downloadSign",
        docId: id,
      });
    
      let fileUrl =
        "https://online.meide-casting.com/meide/REST/knowledgeBase?postType=download&fn=" + storeFilename;
      window.open(fileUrl);
    },
    //单选
    handleSelectionChange(val) {
      this.multipleSelection = val;
  
    },
    reset() {
      this.vModelClass = "";
      this.vModelType = "";
      this.docName = "";
      this.vModelLanguage = "";
      this.vModelField = "";
      this.vModelNation = "";
      this.vModelMainMaterial = "";
      this.vModelZhishi = "";
      this.vModelProductSerial = "";
      this.vModelBiaozhun = "";
    },
    //基本列表
    getList() {
      this.loading = true;

      this.$axios
        .postReq("/meide/REST/knowledgeBase", {
          postType: "docList",
          start: this.start || 1,
          limit: this.limit,
          docClass: this.vModelClass.toString(), //产品分类
          docType: this.vModelType.toString(), //资料类型
          docName: this.docName, //资料名称
          docLanguage: this.vModelLanguage.toString(), //文档语言
          applyArea: this.vModelField.toString(), //领域
          standardNation: this.vModelNation.toString(), //标准国别
          mainMaterial: this.vModelMainMaterial.toString(), //主体材质
          nationalStandard: this.vModelZhishi.toString(), //制式
          standardType: this.vModelBiaozhun.toString(), //标准类型
          productionSerial: this.vModelProductSerial.toString(), //产品系列
        })
        .then((res) => {
          this.loading = false;
          this.list = res.data;
          this.total = res.rowcount;
        });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.start = val;
      this.getList();
    },
    //产品分类下拉
    getProClassList() {
      this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
          postType: "productClass",
        })

        .then((res) => {
          this.classList = res.data;
        });
    },
    //文档类型
    getdocTypeList() {
           this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
         postType: "fromDict",
        libGroup: "docType",
        })
     .then((res) => {
        this.docTypeList = res.data;
      });
    },
    //文档语言
    getlanguageList() {
              this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
        postType: "fromDict",
        libGroup: "docLanguage",
        }).then((res) => {

        this.languageList = res.data;
      });
    },
    //领域下拉
    getFieldList() {
          this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
       postType: "applyArea",
        }).
      then((res) => {
        this.fieldList = res.data;
      });
    },
    //标准国别下拉
    getNationList() {
         this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
       postType: "fromDict",
        libGroup: "standardNation",
        }).then((res) => {
        this.nationList = res.data;
      });
    },
    //主体材质
    getMainMaterialList() {

          this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
         postType: "mainMaterial",
        }).then((res) => {
        this.mainMaterialList = res.data;
      });
    },

    //制式
    getZhishiList() {
         this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
      postType: "fromDict",
        libGroup: "nationalStandard",
        }).then((res) => {
        this.zhishiList = res.data;
      });
    },

    //标准类型
    getBiaozhunList() {
         this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
   postType: "fromDict",
        libGroup: "standardType",
        })
    .then((res) => {
        this.biaozhunList = res.data;
      });
    },

    //产品系列
    getProductSerialList() {
          this.$axios
        .postReq("/meide/REST/knowledgeBaseDict", {
       postType: "productSerial",
        libGroup: this.vModelClass.toString(),
        }).then((res) => {

        this.productSerialList = res.data;
        // this.docTypeList = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>


.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #f42434;
}
.search-container {
  padding: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > div {
    margin-right: 5px;
  }
}
.flex {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  > div {
    margin-right: 5px;
  }
}
</style>